module.exports = __webpack_public_path__ + "img/cabinets-storage.5ca3202.jpg";